module.exports = __webpack_public_path__ + "static/media/omg_brand_banner.886e4200.jpg";